var _polygon, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNumberTen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "73.88 179.36 73.88 104.25 61.75 104.25 61.75 96.22 90.88 74.88 90.88 179.36 73.88 179.36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.46,128.51c0,19.14,9.76,36,28.1,36,16.71,0,27.94-16.66,27.94-36,0-17.53-10.49-35.8-27.94-35.8C131,92.71,120.46,109.08,120.46,128.51Zm73.79,0c0,27.33-17.6,52.61-45.69,52.61-27.36,0-45.85-23.82-45.85-52.61,0-28.64,17-52.46,45.85-52.46C174.58,76.05,194.25,99.29,194.25,128.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,256A128,128,0,1,1,256,128,128.17,128.17,0,0,1,128,256Zm0-241A113,113,0,1,0,241,128,113.15,113.15,0,0,0,128,15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNumberTen);
export default __webpack_public_path__ + "static/media/icon-number-ten.885dc793.svg";
export { ForwardRef as ReactComponent };